import { __assign, __rest } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseShape } from '../base-shape/component.js';
import { pathsMap } from './paths.js';

var SuperEllipse = forwardRef(function (props, ref) { return (React.createElement(BaseShape, __assign({}, props, { pathsMap: pathsMap, ref: ref }))); });
SuperEllipse.displayName = 'SuperEllipse';
var SuperEllipseBlank = forwardRef(function (_a, ref) {
    var pathsMapProp = _a.pathsMap, props = __rest(_a, ["pathsMap"]);
    return (React.createElement(BaseShape, __assign({}, props, { pathsMap: pathsMapProp, ref: ref })));
});
SuperEllipseBlank.displayName = 'SuperEllipseBlank';

export { SuperEllipse, SuperEllipseBlank };
